/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Box, Stack, SwipeableDrawer, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";

import MaterialSymbol from "../../components/MaterialSymbol";
import { CloseButton } from "../../components/Modal";

import AtomicListWrapper from "./AtomicListWrapper";
import { ATOMIC_STREAM_INBOX_ID, useAtomic } from "./AtomicProvider";

const AtomicDrawer = () => {
  const atomic = useAtomic();

  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <SwipeableDrawer
      open={atomic.drawerOpen}
      anchor="right"
      PaperProps={{
        sx: {
          width: isSm ? "100%" : 450,
        },
      }}
      swipeAreaWidth={isSm ? 30 : 0}
      onClose={() => {
        atomic.closeDrawer();
      }}
      onOpen={() => {
        atomic.openDrawer();
      }}
    >
      <Stack padding={2} pl={0} pr={0} marginTop={5} display="flex" flexGrow={1} overflow="hidden">
        <Box padding={2} width="100%">
          <CloseButton
            sx={{ float: "right" }}
            id="notifications--close-button"
            data-testid="notifications--close"
            variant="outlined"
            disableTouchRipple
            onClick={atomic.closeDrawer}
          >
            <Typography variant="body2">Close</Typography>
            <MaterialSymbol>close</MaterialSymbol>
          </CloseButton>
          {atomic.drawerContainerId === ATOMIC_STREAM_INBOX_ID && (
            <Typography variant="h3" pb={3} fontWeight={700} fontSize="32px">
              Notifications
            </Typography>
          )}
        </Box>

        <AtomicListWrapper containerId={atomic.drawerContainerId}></AtomicListWrapper>
      </Stack>
    </SwipeableDrawer>
  );
};

export default AtomicDrawer;
